import React, {Component} from 'react';
import StickButton from "../../../components/StickButton";
import {Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Select from"../../../local_node_modules/react-select"
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";
import Alert from "react-s-alert";

class FaultyDocumentModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            faultyDocumentModal: false,
            selectedDocumentTypes: [],
        };

        this.fetchData = this.fetchData.bind(this);
        this.closeFaultyDocumentModal = this.closeFaultyDocumentModal.bind(this);
        this.openFaultyDocumentModal = this.openFaultyDocumentModal.bind(this);
        this.submitFaultyDocumentModal = this.submitFaultyDocumentModal.bind(this);
        this.closeFaultyDocumentModal = this.closeFaultyDocumentModal.bind(this);
        this.onSelectType = this.onSelectType.bind(this);
        this.deleteFaultyDocumentModal = this.deleteFaultyDocumentModal.bind(this);
    }

    fetchData(){
        let self = this;
        let params = {
            url: `/faultyDocument/fetchFaultyDocument`,
            method: "post",
            data: this.props.customerData.recordId
        };
        request(params).then(function (response) {
            if(response.data===""){
                let selectedDocumentTypes = [{
                    recordId: null,
                    customerRecordId: null,
                    archive: false,
                    invoice: false,
                    despatch: false,
                    expenseNote: false,
                    mm: false,
                    smm: false,
                    date: null
                    }];
            }else{
                self.setState({selectedDocumentTypes: response.data});
            }

        });
    }

    async openFaultyDocumentModal() {
        this.fetchData();
        this.setState({
            faultyDocumentModal: true
        })
    }

    submitFaultyDocumentModal() {
        let params = {
            url: `/faultyDocument/save`,
            method: 'post',
            data: {
                recordId: this.state.selectedDocumentTypes.recordId !== undefined ? this.state.selectedDocumentTypes.recordId : "",
                customerRecordId: this.props.customerData.recordId,
                archive: this.state.selectedDocumentTypes.archive !== undefined ? this.state.selectedDocumentTypes.archive : false,
                invoice: this.state.selectedDocumentTypes.invoice !== undefined ? this.state.selectedDocumentTypes.invoice : false,
                despatch: this.state.selectedDocumentTypes.despatch !== undefined ? this.state.selectedDocumentTypes.despatch : false,
                expenseNote: this.state.selectedDocumentTypes.expenseNote !== undefined ? this.state.selectedDocumentTypes.expenseNote : false,
                mm: this.state.selectedDocumentTypes.mm !== undefined ? this.state.selectedDocumentTypes.mm : false,
                smm: this.state.selectedDocumentTypes.smm !== undefined ? this.state.selectedDocumentTypes.smm : false,
                date: this.state.date
            }
        };
        request(params).then(function (response) {
            Alert.success("İşleminiz başarıyla gerçekleşti.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
        });
        this.setState({faultyDocumentModal: false});
    }

    closeFaultyDocumentModal() {
        this.setState({faultyDocumentModal: false});
    }

    deleteFaultyDocumentModal(){
        let self = this;
        if (self.state.selectedDocumentTypes.recordId === undefined){
            Alert.error("Var olan bir kaydınız yoktur.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 4000
            });
        }else{
            let params = {
                url: `/faultyDocument/deleteFaultyDocument`,
                method: "post",
                data: this.state.selectedDocumentTypes.recordId
            };
            request(params).then(function (response) {
                let selectedDocumentTypes = [{
                    recordId: null,
                    customerRecordId: null,
                    archive: false,
                    invoice: false,
                    despatch: false,
                    expenseNote: false,
                    mm: false,
                    smm: false,
                    date: null
                }];
                self.setState({selectedDocumentTypes});
                Alert.success("İşleminiz başarıyla gerçekleşti.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
            }).catch(function (error) {
                showAxiosError(error);
            });
        }
    }

    onSelectType(e){
       let name = e.target.name;
       let value = e.target.checked;
       let selectedDocumentTypes = this.state.selectedDocumentTypes;
       selectedDocumentTypes[name] = value;
       this.setState({selectedDocumentTypes});
    }

    render() {

        return (
            <div>
                <div>{this.state.alert}</div>

                <div className="col-sm-12 row">
                    <div className="col-sm-6 row">
                        <StickButton position="leftSide"
                                     label="Hatalı Belgeler"
                                     className="TekBtn referans"
                                     onClick={() => this.openFaultyDocumentModal()}/>
                    </div>
                </div>

                <Modal isOpen={this.state.faultyDocumentModal}>
                    <ModalHeader toggle={() => this.closeFaultyDocumentModal()}>Hatalı Belgeler</ModalHeader>
                    <ModalBody>

                        <div className="col-sm-4" style={{padding: '0', marginTop: '-4px'}}>
                            <label className="col-sm-12" style={{padding: '0'}}>e-Fatura</label>
                            <Input type="checkbox" checked={this.state.selectedDocumentTypes.invoice} value={this.state.selectedDocumentTypes.invoice}
                                   name={"invoice"} onChange={(e) => this.onSelectType(e)}/>
                        </div>

                        <div className="col-sm-4" style={{padding: '0', marginTop: '-4px'}}>
                            <label className="col-sm-12" style={{padding: '0'}}>e-Arşiv Fatura</label>
                            <Input type="checkbox" checked={this.state.selectedDocumentTypes.archive} value={this.state.selectedDocumentTypes.archive}
                                   name={"archive"} onChange={(e) => this.onSelectType(e)}/>
                        </div>

                        <div className="col-sm-4" style={{padding: '0', marginTop: '-4px'}}>
                            <label className="col-sm-12" style={{padding: '0'}}>e-İrsaliye</label>
                            <Input type="checkbox" checked={this.state.selectedDocumentTypes.despatch} value={this.state.selectedDocumentTypes.despatch}
                                   name={"despatch"} onChange={(e) => this.onSelectType(e)}/>
                        </div>

                        <div className="col-sm-4" style={{padding: '0', marginTop: '-4px'}}>
                            <label className="col-sm-12" style={{padding: '0'}}>e-Müstahsil</label>
                            <Input type="checkbox" checked={this.state.selectedDocumentTypes.mm} value={this.state.selectedDocumentTypes.mm}
                                   name={"mm"} onChange={(e) => this.onSelectType(e)}/>
                        </div>

                        <div className="col-sm-4" style={{padding: '0', marginTop: '-4px'}}>
                            <label className="col-sm-12" style={{padding: '0'}}>e-Serbest Meslek</label>
                            <Input type="checkbox" checked={this.state.selectedDocumentTypes.smm} value={this.state.selectedDocumentTypes.smm}
                                   name={"smm"} onChange={(e) => this.onSelectType(e)}/>
                        </div>

                        <div className="col-sm-4" style={{padding: '0', marginTop: '-4px'}}>
                            <label className="col-sm-12" style={{padding: '0'}}>e-Gider Pusulası</label>
                            <Input type="checkbox" checked={this.state.selectedDocumentTypes.expenseNote} value={this.state.selectedDocumentTypes.expenseNote}
                                   name={"expenseNote"} onChange={(e) => this.onSelectType(e)}/>
                        </div>

                    </ModalBody>
                    <ModalFooter>
                        <nav className="col-sm-12 row">
                            <div className="col-sm-3">
                                <button position="leftSide"
                                        label="İptal"
                                        className="TekBtn vazgec"
                                        style={{background: 'rgb(158, 158, 158)', padding:'9px 37px 9px 14px'}}
                                        onClick={() => this.closeFaultyDocumentModal()}> İptal </button>
                            </div>
                            <div className="col-sm-3">
                                <button position="leftSide"
                                        label="Sil"
                                        className="TekBtn vazgec"
                                        style={{background: 'rgb(220, 20, 60)', padding:'9px 37px 9px 14px'}}
                                        onClick={() => this.deleteFaultyDocumentModal()}> Sil </button>
                            </div>
                            <div className="col-sm-3"></div>
                            <div className="col-sm-3">
                                <button position="rightSide"
                                        label="Onayla"
                                        className="TekBtn kaydet"
                                        style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', padding:'9px 37px 9px 14px'}}
                                        onClick={() => this.submitFaultyDocumentModal()}> Onayla</button>
                            </div>
                        </nav>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default FaultyDocumentModal;